export default __webpack_public_path__ + "c532c4479d86c3865b04fcf113129e9d.svg";